import { render } from "./AlDepositHistory.vue?vue&type=template&id=5e4ea72c&ts=true"
import script from "./AlDepositHistory.vue?vue&type=script&lang=ts"
export * from "./AlDepositHistory.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__